import { gql } from '@graphql/__generated__';

export const ACTIVITY_BANNER_QUERY = gql(/* GraphQL */ `
  query ActivityBanner($userId: uuid!) {
    lead_agents_aggregate(
      where: { user_id: { _eq: $userId }, source: { _eq: result_page } }
    ) {
      aggregate {
        count
      }
    }
    enquiries_aggregate(where: { broker_id: { _eq: $userId } }) {
      aggregate {
        count
      }
    }
  }
`);
